import {
  OffsetDateTime,
  OffsetDateTimeProps,
} from "@/shared/form/offset-date-time";

export function DynamicAttributeFieldSimpleDatetime(
  props: OffsetDateTimeProps,
) {
  return <OffsetDateTime allowClear {...props} />;
}
